import type { ComposerSubmitComment } from '@liveblocks/react-ui/primitives'

import { CommentComposer } from '@/components/lemmala-design-system/comment-composer/comment-composer'
import { COMMENT_MAX_LENGTH, EDITOR_COMPONENTS } from '@/components/shared/comment/consts'

type AssessmentCommentComposerProps = {
  placeholder: string
  onSubmit: (comment: ComposerSubmitComment) => void
  autoFocus?: boolean
}

export const AssessmentCommentComposer = ({
  placeholder,
  onSubmit,
  autoFocus,
}: AssessmentCommentComposerProps) => (
  <CommentComposer
    actionsAppearance='icon'
    maxLength={COMMENT_MAX_LENGTH}
    editorComponents={EDITOR_COMPONENTS}
    placeholder={placeholder}
    onSubmit={onSubmit}
    autoFocus={autoFocus}
  />
)
